import script from "./CardInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CardInfo.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=c6547d80&scoped=true&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-c6547d80"]])

export default __exports__